import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';
import { GridLines } from './GridLines.js';
import { computeGridLines } from './utils/compute-grid-lines.js';
import { shouldHighlightZeroLine } from './utils/should-highlight-zero-line.js';

export type GridRowsProps = {
  scale: AnyScale;
  width: number;
  numTicks?: number;
  offset?: number;
  highlightZeroLine?: boolean;
  ticks?: number[];
};

export const GridRows = ({
  scale,
  width,
  numTicks,
  offset,
  highlightZeroLine = true,
  ticks,
}: GridRowsProps) => {
  if (ticks) {
    const typedScale = scale as (value: number) => number | undefined;
    const lines = ticks.map((tick, index) => ({
      from: { x: 0, y: Math.max(0, typedScale(tick) ?? 0) },
      to: { x: width, y: Math.max(0, typedScale(tick) ?? 0) },
      index,
    }));
    return (
      <GridLines
        lines={lines}
        highlightAccessor={(from, to) =>
          highlightZeroLine &&
          !isBandScale(scale) &&
          shouldHighlightZeroLine(from, to, scale)
        }
      />
    );
  }

  return (
    <GridLines
      lines={computeGridLines(scale, numTicks, offset, width, 'y')}
      highlightAccessor={(from, to) =>
        highlightZeroLine &&
        !isBandScale(scale) &&
        shouldHighlightZeroLine(from, to, scale)
      }
    />
  );
};
